import React from 'react';
interface HolographicButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  id?: string;
}
export function HolographicButton({
  children,
  href,
  className = '',
  variant = 'primary',
  size = 'md',
  onClick,
  id,
  ...props
}: HolographicButtonProps) {
  const sizeClasses = {
    sm: 'py-2 px-5 text-sm',
    md: 'py-3 px-8 text-base',
    lg: 'py-3.5 px-10 text-lg'
  };
  const variantClasses = {
    primary: 'bg-primary-500 hover:bg-primary-600 text-white shadow-md hover:shadow-lg',
    secondary: 'bg-white hover:bg-warm-100 text-primary-600 border border-primary-200 shadow-sm hover:shadow-md'
  };
  const baseClasses = `
    relative overflow-hidden rounded-xl font-semibold text-center
    transition-all duration-300 transform hover:-translate-y-0.5
    ${sizeClasses[size]}
    ${variantClasses[variant]}
    ${className}
  `;
  const shimmerEffect = <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 pointer-events-none" data-id="element-155" />;
  const handleClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) onClick(e);
  };
  if (href) {
    if (href.startsWith('#')) {
      return <a href={href} onClick={handleClick} className={`inline-block ${baseClasses}`} id={id} data-id="element-156">
          <span className="relative z-10" data-id="element-157">{children}</span>
          {shimmerEffect}
        </a>;
    }
    return <a href={href} onClick={handleClick} target="_blank" rel="noopener noreferrer" className={`inline-block ${baseClasses}`} id={id} data-id="element-158">
        <span className="relative z-10" data-id="element-159">{children}</span>
        {shimmerEffect}
      </a>;
  }
  return <button onClick={handleClick} className={baseClasses} id={id} {...props} data-id="element-160">
      <span className="relative z-10" data-id="element-161">{children}</span>
      {shimmerEffect}
    </button>;
}